import { useGetBrandingConfigQuery } from '../../../store/chatbox/chatboxApi';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';
import { classNames } from '../../../utils/classNames';
import VideoBg from '../video-bg/VideoBg';

const LogoHomepage = () => {
	const { data: userInfo, isLoading } = useGetCurrentUserQuery();
	const {data: brand} = useGetBrandingConfigQuery(userInfo?.hotelInfo.username || '', {
		skip: !userInfo?.id
	});
	return (
		<div className='max-w-full md:w-[760px] relative mx-auto my-10'>
			{!isLoading && <div className="relative w-full h-[465px] rounded-2xl overflow-hidden z-0 flex">
				{userInfo?.logoUrl ? 
					<VideoBg url="/video/white-abstract-fabric-background.mp4" /> : 
					<img 
						// src="/images/athens-bar.jpg" 
						src={process.env.REACT_APP_PROJECT === 'nynn' ? '/images/athens-bar.jpg' : brand?.metadata.chatMainImage}
						alt={userInfo?.name}
						className="absolute w-full h-full object-cover top-0 left-0 p-0 -z-10" />
				}
				<div className="absolute w-full h-full object-cover top-0 left-0 p-0 -z-10 bg-white bg-opacity-40" />
				<img 
					// src={userInfo?.logoUrl || '/images/logo.png'} 
					src={process.env.REACT_APP_PROJECT === 'nynn' ? '/images/logo.png' : userInfo?.logoUrl || brand?.metadata.chatOverlayLogo}
					className={classNames('m-auto', userInfo?.logoUrl ? 'rounded-full max-w-80' : '')} alt={userInfo?.name} />
            </div>}
		</div>
	)
}

export default LogoHomepage;